import { WizardSchemaType } from "../index";
import { Grid, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { EVENT_COLORS } from "@onair/ui/event/constants";
import { ImagePlaceholderSvg } from "@onair/ui/svg/image-placeholder";
import dayjs, {
	FORMAT_TIME,
} from "@onair/utils/dayjs";
import { Iconify } from "@onair/minimal-ui/iconify";

interface PropTypes {
	data: WizardSchemaType["stepResource"]["agendas"][0];
}

const AgendaPreviewItem = ({ data }: PropTypes) => {
	const colors = EVENT_COLORS;

	const img = React.useMemo(() => {
		return (
			<Box
				display="flex"
				alignItems="center"
				justifyContent="center"
				className="w-full h-[120px] rounded-lg"
				borderColor="divider"
				bgcolor={colors.bgColor}
				border={`1px solid ${colors.borderColor}`}
				sx={{
					backgroundImage: data.thumbnail
						? `url(${typeof data.thumbnail === "string" ? data.thumbnail : URL.createObjectURL(data.thumbnail as Blob)})`
						: "",
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			/>
		);
	}, [data.thumbnail]);

	return (
		<Grid item xs={12}>
			<Grid container spacing={1.5}>
				<Grid item xs={3}>
					<Stack spacing={1}>
						{data.startDate && data.endDate ? (
							<Typography
								variant="subtitle2"
								color={colors.color}
								fontSize={12}
							>
								{dayjs(data.startDate).format(FORMAT_TIME)} -{" "}
								{dayjs(data.endDate).format(FORMAT_TIME)}
							</Typography>
						) : (
							<Box
								className="w-full h-5 rounded-lg"
								bgcolor={colors.bgColor}
								border={`1px solid ${colors.borderColor}`}
							/>
						)}
						{data.thumbnail ? (
							img
						) : (
							<Box
								display="flex"
								alignItems="center"
								justifyContent="center"
								className="w-full h-[120px] rounded-lg"
								bgcolor={colors.bgColor}
								border={`1px solid ${colors.borderColor}`}
							>
								<ImagePlaceholderSvg />
							</Box>
						)}
					</Stack>
				</Grid>
				<Grid item xs={8}>
					<Stack spacing={1}>
						{data.title ? (
							<Typography
								variant="subtitle2"
								color={colors.color}
								fontSize={12}
								sx={{
									wordBreak: "break-all",
								}}
							>
								{data.title}
							</Typography>
						) : (
							<Box
								className="w-full h-5 rounded-lg"
								bgcolor={colors.bgColor}
								border={`1px solid ${colors.borderColor}`}
							/>
						)}
						{data.content ? (
							<Typography
								variant="body2"
								color={colors.color}
								fontSize={12}
								sx={{
									wordBreak: "break-all",
								}}
							>
								{data.content}
							</Typography>
						) : (
							<Box
								display="flex"
								alignItems="center"
								justifyContent="center"
								className="w-full h-[120px] rounded-lg"
								bgcolor={colors.bgColor}
								border={`1px solid ${colors.borderColor}`}
							/>
						)}
					</Stack>
				</Grid>
				<Grid item xs={1}>
					<Box
						className="size-5 rounded-full flex"
						alignItems="center"
						justifyContent="center"
						bgcolor={colors.bgColor}
						border={`1px solid ${colors.borderColor}`}
					>
						<Iconify
							width={16}
							icon="eva:arrow-ios-downward-fill"
							color={colors.color}
						/>
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default AgendaPreviewItem;
